import { useContext } from 'react';
import {
  FrontDeskContext,
  type FrontDeskContextValue,
} from './frontDeskContextValue';

export function useFrontDeskView(): FrontDeskContextValue {
  const ctx = useContext(FrontDeskContext);
  if (!ctx) throw new Error('useFrontDeskView must be used within a FrontDeskProvider');
  return ctx;
}
